import moment from "moment-timezone";

export const YOUTUBE_PRIVACY = {
  PUBLIC: "public",
  PRIVATE: "private",
  UNLISTED: "unlisted",
};

export const TIKTOK_PRIVACY = {
  SELF_ONLY: "SELF_ONLY",
  MUTUAL_FOLLOW_FRIENDS: "MUTUAL_FOLLOW_FRIENDS",
  FOLLOWER_OF_CREATOR: "FOLLOWER_OF_CREATOR",
  PUBLIC_TO_EVERYONE: "PUBLIC_TO_EVERYONE",
};

export const TIKTOK_PRIVACY_LABELS = {
  [TIKTOK_PRIVACY.SELF_ONLY]: "Only me",
  [TIKTOK_PRIVACY.MUTUAL_FOLLOW_FRIENDS]: "Friends",
  [TIKTOK_PRIVACY.FOLLOWER_OF_CREATOR]: "Followers",
  [TIKTOK_PRIVACY.PUBLIC_TO_EVERYONE]: "Public",
};

export const TIKTOK_PUBLISH_MODE = {
  DIRECT: "direct",
  INBOX: "inbox",
};

export const YOUTUBE_CATEGORIES = [
  { id: "1", label: "Film & Animation" },
  { id: "2", label: "Autos & Vehicles" },
  { id: "10", label: "Music" },
  { id: "15", label: "Pets & Animals" },
  { id: "17", label: "Sports" },
  { id: "20", label: "Gaming" },
  { id: "22", label: "People & Blogs" },
  { id: "23", label: "Comedy" },
  { id: "24", label: "Entertainment" },
  { id: "25", label: "News & Politics" },
  { id: "26", label: "Howto & Style" },
  { id: "27", label: "Education" },
  { id: "28", label: "Science & Technology" },
  { id: "29", label: "Nonprofits & Activism" },
];

export const REPEAT_OPTIONS = {
  NO_REPEAT: "no_repeat",
  ONCE: "once",
  EVERY_DAY: "every_day",
  EVERY_WEEK: "every_week",
  EVERY_MONTH: "every_month",
  EVERY_YEAR: "every_year",
};

export const SOCIAL_TYPES = {
  LINKEDIN: "linkedin",
  INSTAGRAM: "instagram",
  FACEBOOK: "facebook",
  TELEGRAM: "telegram",
  TWITTER: "twitter",
  TIKTOK: "tiktok",
  REDDIT: "reddit",
  YOUTUBE: "youtube",
  THREADS: "threads",
};

// Threads post chains (OP#3464 / OP#3469): part 1 is the composer's own text and media, the following parts
// go out as replies to it (`type_data.threads.replies`). Every limit of the chain lives here, so a product
// decision changes one number. The server checks the same limits (OP#3466) and stays the authority.
export const THREADS_LIMITS = {
  // Part 1 included. The server rejects more (services.threads.max_thread_parts).
  MAX_PARTS: 10,
  // Threads characters per part, counted by utils/threadsText.js::threadsTextLength.
  MAX_TEXT_LENGTH: 500,
  // Media in part 1: unchanged for single Threads posts.
  MAX_ROOT_FILES: 10,
  // Media in each reply (Meta's carousel maximum).
  MAX_REPLY_FILES: 20,
  // Meta refuses a post with more unique links (THREADS_API__LINK_LIMIT_EXCEEDED).
  MAX_LINKS: 5,
};

let threadsPartSeq = 0;

// A reply of a Threads chain as the composer keeps it. `key` is a client-only id for React lists; it is never
// sent to the server.
export const newThreadsPart = (part = {}) => {
  threadsPartSeq += 1;
  return {
    key: `tp-${Date.now().toString(36)}-${threadsPartSeq}`,
    text: typeof part.text === "string" ? part.text : "",
    files: Array.isArray(part.files) ? part.files.filter((id) => id !== null && id !== undefined && id !== "") : [],
  };
};

export const CONTENT_TYPES = {
  TEXT: "text",
  MEDIA: "media",
};

export const ACTIVE_DATE_TYPES = {
  FROM: "from",
  TO: "to",
};

export const DEFAULT_STATE = {
  files: [],
  accounts: [],
  selectedFiles: [],
  selectedAccounts: [],
  draftCollections: [],
  selectedDrafts: [],
  posts: [],
  groups: [],
  metaData: {},
  selectedImage: null,
  selectedIndex: 0,
  postID: null,
  showAccountsInfo: true,
  open: false,
  openIconsDialog: false,
  tags: [],
  selectedTime: moment(),
  selectedDate: moment(),
  anchorEl: null,
  popoverOpen: false,
  typeContent: CONTENT_TYPES.TEXT,
  snackbarOpen: false,
  snackbarMessage: "",
  isEditing: false,
  alertOpen: false,
  alertErrorOpen: false,
  alertMessage: "",
  hasUnsavedChanges: false,
  isUnsavedDialogOpen: false,
  repeatOption: REPEAT_OPTIONS.NO_REPEAT,
  fromDate: null,
  activeDate: ACTIVE_DATE_TYPES.FROM,
  toDate: null,
  isDragging: false,
  draggedImageIndex: null,
  dragOverIndex: null,
  tempSelAccs: [],
  scheduleEnabled: false,
  postTitle: "",
  postText: "",
  youtubePrivacy: YOUTUBE_PRIVACY.PUBLIC,
  youtubeCategoryId: "22",
  tiktokPrivacyLevel: null,
  tiktokPublishMode: TIKTOK_PUBLISH_MODE.DIRECT,
  tiktokDisableComment: false,
  tiktokDisableDuet: false,
  tiktokDisableStitch: false,
  tiktokVideoCoverTimestampMs: 1000,
  tiktokPhotoCoverIndex: 0,
  tiktokAutoAddMusic: true,
  tiktokBrandContentToggle: false,
  tiktokBrandOrganicToggle: false,
  // Threads chain: parts 2..N as [{ key, text, files }] (see THREADS_LIMITS).
  threadsReplies: [],
  // Which part the media dialog fills: null = part 1 (selectedFiles), or the index in threadsReplies.
  mediaTarget: null,
  mediaTargetBase: [],
};
